import api from './api';

class UserLanguageService {
  async getLanguages(): Promise<string[]> {
    const response = await api.get('/api/users/languages');
    return response.data.data ?? [];
  }

  async setLanguages(languages: string[]): Promise<string[]> {
    const response = await api.put('/api/users/languages', { languages });
    return response.data.data;
  }
}

export const userLanguageService = new UserLanguageService();
